module.exports = __webpack_public_path__ + "static/img/wecomCode.72a1196.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wecomCode.jpg
// module id = nGKc
// module chunks = 1